import { Page } from '@/core/architecture'

import { EmailAddressSettingsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * EmailAddressSettings Page
 * Implemented as a practical sample.
 */
export const EmailAddressSettings: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <EmailAddressSettingsTemplate
      state={state}
      updateEmail={actions.updateEmail}
      sendVerificationMail={actions.sendVerificationMail}
      resendVerificationMail={actions.resendVerificationMail}
      sendVerificationMailSocial={actions.sendVerificationMailSocial}
      onCloseCompleteModal={actions.onCloseCompleteModal}
    />
  )
}
